import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const createRouter = () => new Router({
    routes: []
});

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

//const routerPush = Router.prototype.push
//Router.prototype.push = function push(location) {
 // return routerPush.call(this, location).catch(error => error)
//}
export default router;